import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {

  const token = localStorage.getItem(
    "indiaboatsAdminToken"
  );

  if (!token) {
    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;